import { mapActions, mapState } from 'vuex'
import AppointmentService from '../../../../services/appointment/appointmentService'
import LocationService from '../../../../services/masters/LocationService'
import serviceUser from '../../../../services/user/UserService'
const holidaysApi = require('colombia-holidays');
import dayjs from "dayjs";

export default {
    props: ['providerId'],
    data() {
        return {
            statesData: [],
            citiesData: [],
            scheduleRangeData: [],
            state: null,
            city: null,
            range: null,
            branch: null,
            shippingDate: {},
            scheduleRange: null,
            observation: null,
            cityIsLoading: false,
            cellPhone: null,
            phone: null,
            minDate: {},
            notAllowedDays: [0],
            monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            dayNames: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
            holidays: [],
            branches: [],
            address: '',
            idBranches: '',
            idBranch: '',
            enabledDays: [],
            formattedDate: '',
            deliveryPoint: '',
            deliveryPoints: [],
            enabledDaysArray: [],
            appointmentDate: null,
            scheduleRanges: [],
            date: ''
        }
    },

    created() {
        this.getStates()
    },

    computed: {
        ...mapState('delivery', {
            provider: 'provider'
        }),
        ...mapState('auth', [
            'user',
            'identification',
            'identificationType'
        ]),

        isNextButtonDisable() {
            return (
                this.scheduleRange === null ||
                this.scheduleRange === undefined ||
                this.scheduleRange === '' ||
                this.appointmentDate == null ||
                this.appointmentDate == undefined ||
                this.appointmentDate == '' ||
                this.deliveryPoint == null ||
                this.deliveryPoint == undefined ||
                this.deliveryPoint == '' ||
                this.phone == null ||
                this.phone == undefined ||
                this.phone == '' ||
                this.cellPhone == null ||
                this.cellPhone == undefined ||
                this.cellPhone == ''
            )
        }

    },

    watch: {
        state() {
            this.getCities()
        },

        city() {
            this.getDeliveryPoints()
        },
    },

    methods: {
        contains(arr, id) {
            return arr.some(e => e.id === id)
        },

        async getStates() {
            try {
                const response = await LocationService.getStatesWithDeliveryPoint()
                this.statesData = response.data
            } catch (error) {
            }
        },

        async getCities() {
            try {
                this.cityIsLoading = true
                const data = {
                    ids: [this.state]
                }
                const result = await LocationService.getCitiesWithDeliveryPoint(data)
                this.citiesData = result.data
                this.cityIsLoading = false
            } catch (error) {
                this.cityIsLoading = false
            }
        },

        async getDeliveryPoints() {
            try {
                let response = await AppointmentService.getDeliveryPointByCity(this.city)
                this.deliveryPoints = response.data
                this.deliveryPoint = ''
                this.address = ''
                this.$forceUpdate()
            } catch (error) {
            }
        },

        async branchesAppointment() {
            let branch = [];
            const response = await AppointmentService.getBranchesAppointment(this.city)
            const branches = response.data

            branches.forEach(branche => {
                branche.idDeliveryPoint.idBranch = branche.id;
                branch.push(branche.idDeliveryPoint)

            });
            this.idBranches = branch
            this.branches = branch.map((namePharmacys) => {
                return { name: namePharmacys.name, id: namePharmacys.id, address: namePharmacys.address }
            })

        },
        async getAddressAndAllowedDates() {
            let aux = this.deliveryPoints.find(dp => dp.id == this.deliveryPoint)
            this.address = aux.address

            try {
                let response = await AppointmentService.getAllowedDates(this.deliveryPoint, false)
                this.enabledDays = response.data
                this.enabledDaysArray = this.enabledDays.map(d => {
                    const input = d.date.split("-");
                    return new Date(input[0], input[1] - 1, input[2]);
                })
            } catch (error) {
            } 
        },

        async getScheduleRanges() {
            this.date = dayjs(this.appointmentDate).format('YYYY-MM-DD')

            const selectedDate = this.enabledDays.find(date => date.date == this.date)
            try {
                if (selectedDate) {
                    let response = await AppointmentService.getScheduleRanges(selectedDate.id, false)
                    if (response.data.length === 0) {
                        this.$buefy.toast.open({
                            message: 'No hay turnos disponibles para la fecha seleccionada',
                            type: "is-warning"
                        });
                    } else {
                        this.scheduleRanges = response.data
                    }
                }
                this.scheduleRange = ''
            } catch (error) {
                console.log(error)
            }
        },

        filterKeyCount(e) {
            const key = e.key;
            if (/[0-9]/.test(key)) { } else {
              return e.preventDefault();
            }
        },

        ...mapActions(
            'delivery',
            [
                'setShippingDate',
                'setState',
                'setCity',
                'setSchedule',
                'setScheduleName',
                'setObservations',
                'setDeliveryPoint',
                'setDeliveryPointName',
                'setDeliveryPointAddress',
                'setAppointmentDate',
                'setPhone',
                'setCellPhone'
            ]
        ),
        async nextPage() {
            if (this.cellPhone[0] !== '3' || this.cellPhone.length !== 10) {
                this.$buefy.toast.open({
                    message: 'El número celular tiene un formato erróneo',
                    type: "is-warning"
                });
                return;
            }
            if (this.phone.length < 7 || this.phone.length > 10) {
                this.$buefy.toast.open({
                    message: 'El número de teléfono tiene un formato erróneo',
                    type: "is-warning"
                });
                return;
            }
            if (this.phone) this.setPhone(this.phone)
            if (this.cellPhone) this.setCellPhone(this.cellPhone)
            if (this.shippingDate) this.setShippingDate(this.shippingDate)
            if (this.state) this.setState(this.state)
            if (this.city) this.setCity(this.city)
            if (this.deliveryPoint) {
                const deliveryPoint = this.deliveryPoints.find(dp => dp.id == this.deliveryPoint)
                this.setDeliveryPoint(deliveryPoint.id)
                this.setDeliveryPointName(deliveryPoint.name)
                this.setDeliveryPointAddress(deliveryPoint.address)
            }
            this.setAppointmentDate(this.date)
            if (this.scheduleRange) {
                const scheduleRange = this.scheduleRanges.find(scheduleRange => scheduleRange.id == this.scheduleRange)
                this.setSchedule(scheduleRange.id)
                this.setScheduleName(scheduleRange.range)
            }
            if (this.observation) this.setObservations(this.observation)
            this.$emit('nextStep')
        }
    }
}